// extracted by mini-css-extract-plugin
export var askAiIcon = "_ny-9";
export var container = "_ny-0";
export var groupSeparator = "_ny-a";
export var highlight = "_ny-4";
export var resultIcon = "_ny-5";
export var resultItem = "_ny-7";
export var resultSubtitle = "_ny-3";
export var resultTitle = "_ny-2";
export var resultsList = "_ny-1";
export var searchGroup = "_ny-6";
export var selected = "_ny-8";